import request from "@/utils/request.js";
//机房api
export function fetchCheckList(params) {
    return request({
        url: '/computer-check',
        method: 'GET',
        params
    })
}
export function addCheckList(data) {
    return request({
        url: '/computer-check',
        method: 'POST',
        data
    })
}
export function fetchComputerRoom(id) {
    return request({
        url: `/computer-room/${id}`,
        method: 'get'
    })
}
export function fetchComputerCheck(id) {
    return request({
        url: `/computer-check/${id}`,
        method: 'get'
    })
}
export function fetchRoomStatus() {
    return request({
        url: `/computer-room/status`,
        method: 'get'
    })
}
//以上废弃

// 设备api
export function fetchShopfloorList(params, modulesUuid = 'device') {
    return request({
        url: '/v2/inspect/record/device',
        method: 'GET',
        params: { ...params, modulesUuid }
    })
}
export function addShopfloorList(data) {
    return request({
        url: '/v2/inspect/record/device',
        method: 'POST',
        data
    })
}
export function fetchShopfloorCheck(id) {
    return request({
        url: `/v2/inspect/record/device/${id}`,
        method: 'get'
    })
}
export function fetchShopfloorRoom(id,params) {
    return request({
        url: `/v2/inspect/object/device/${id}`,
        method: 'get',
        params
    })
}

export function fetchShopfloorStatus(params, modulesUuid = 'device') {
    return request({
        url: '/v2/inspect/object/device/status',
        method: 'get',
        params: { ...params, modulesUuid }
    })
}
